import { render, staticRenderFns } from "./swipepay.vue?vue&type=template&id=93b15934&"
import script from "./swipepay.vue?vue&type=script&lang=js&"
export * from "./swipepay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports